import React from "react";
import { ArrowRightIcon, LockIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  sub?: string;
  id?: string;
  dark?: boolean;
};
export function CtaButton({
  label,
  sub,
  id,
  dark = false
}: CtaButtonProps) {
  return <div className="flex w-full flex-col items-center" data-id="element-86" data-mp="ck9fhpb7rudw">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-gold px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-tight tracking-tight text-ink shadow-[0_6px_0_0_#B9801A] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#F6C056] active:translate-y-1 active:shadow-[0_2px_0_0_#B9801A] focus:outline-none focus-visible:ring-4 focus-visible:ring-teal sm:text-xl" data-id="element-87" data-mp="cjhluk16g6q9">
        <span data-id="element-88" data-mp="159q40bvpqr4u">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-89" data-mp="15ahoornrv4gc" />
      </a>
      {sub && <p className={`mt-4 flex max-w-xl items-start justify-center gap-1.5 text-center text-sm ${dark ? "text-white/70" : "text-ink/65"}`} data-id="element-90" data-mp="39yhozs5wpped">
          <LockIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-91" data-mp="3ex2r5x4pyj5g" />
          <span data-id="element-92" data-mp="3jx76hjtw57u3">{sub}</span>
        </p>}
    </div>;
}